import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { adminMe, adminLogout } from '@/utils/adminApi';
import { AdminLogin } from '@/components/admin/AdminLogin';
import { AnnouncementGenerator } from '@/components/admin/AnnouncementGenerator';

export const ADMIN_COLORS = {
  bg: '#0B1220', card: '#131B2E', field: 'rgba(255,255,255,0.06)', border: 'rgba(255,255,255,0.14)',
  primary: '#FFFFFF', secondary: '#D5DEEA', muted: '#9FB0C6', accent: '#FCD34D', accentInk: '#1A1204',
};

export default function AdminPage() {
  const [user, setUser] = useState(null); // null = checking, false = signed out

  useEffect(() => {
    document.title = 'Falak — Admin';
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    adminMe().then(setUser).catch(() => setUser(false));
    return () => meta.remove();
  }, []);

  const logout = async () => { await adminLogout(); setUser(false); };

  return (
    <div dir="rtl" className="min-h-screen" style={{ background: ADMIN_COLORS.bg, color: ADMIN_COLORS.primary }} data-testid="admin-page">
      {user === null && (
        <div className="flex justify-center pt-32" data-testid="admin-checking"><Loader2 className="animate-spin" /></div>
      )}
      {user === false && <AdminLogin onLogin={setUser} />}
      {user && <AnnouncementGenerator user={user} onLogout={logout} onUnauthorized={() => setUser(false)} />}
    </div>
  );
}
